/**
 * @name ERROR_TYPES
 * @enum string
 * @type {{INVALID_SPIN: string, PARTNER_NOT_FOUND: string, INVALID_OPERATION: string, SPIN_NOTFOUND: string, BUY_BONUS_DISABLED: string, INVALID_TOKEN: string, INVALID_AMOUNT: string, INVALID_SPIN_COUNT: string, MONEY_TRANSACTION_ERROR: string, NOT_ENOUGH_MONEY: string}}
 */
export const ERROR_TYPES = {
  INVALID_TOKEN: 'INVALID_TOKEN',
  INVALID_SPIN: 'INVALID_SPIN',
  MONEY_TRANSACTION_ERROR: 'MONEY_TRANSACTION_ERROR',
  NOT_ENOUGH_MONEY: 'NOT_ENOUGH_MONEY',
  INVALID_OPERATION: 'INVALID_OPERATION',
  SPIN_NOTFOUND: 'SPIN_NOTFOUND',
  INVALID_SPIN_COUNT: 'INVALID_SPIN_COUNT',
  INVALID_AMOUNT: 'INVALID_AMOUNT',
  BUY_BONUS_DISABLED: 'BUY_BONUS_DISABLED',
  PARTNER_NOT_FOUND: 'PARTNER_NOT_FOUND',
  PlayerLimitExceeded: 'PlayerLimitExceeded',
};